import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home.vue'
import Login from './views/login.vue'
import Orderfrom from './views/orderfrom.vue'
import Orderdetail from './views/orderdetail.vue'
import Code from './views/code.vue'
import Stock from './views/stock.vue'
import Numbermanage from './views/numbermanage.vue'
import Sellinput from './views/sellinput.vue'
import Waitorder from './views/waitorder.vue'
import Selldetail from './views/selldetail.vue'
import Waitpayorder from './views/waitpayorder.vue'
import Fulfilorder from './views/fulfilorder.vue'
import Cancelledorder from './views/cancelledorder.vue'
import Failorder from './views/failorder.vue'
import Draftbox from './views/draftbox.vue'
import Voidapply from './views/voidapply.vue'
import Voiddetail from './views/voiddetail.vue'
import Orderbillcount from './views/orderbillcount.vue'
import Billmanage from './views/billmanage.vue'
import Inventorydetails from './views/inventorydetails.vue'
import Returnorder from './views/returnorder.vue'
import Returnorderdetails from './views/returnorderdetails.vue'
import SupplierAllBack from './views/supplierAllBack.vue'

Vue.use(Router)
const router = new Router({
    routes: [
        {  
            path: '/',
            redirect: '/login',
            component: Login
        }, 
        {
            path: '/login',
            component: Login
        },
        {
            path: '/home',
            component: Home,
            redirect:'/sellinput',
            children:[
                {
                    path: '/orderfrom',
                    name: '订货单',
                    component: Orderfrom,
                    meta: { title: '订货单' },
                },
                {
                    path: '/orderdetail',
                    name: '订货单详情',
                    component: Orderdetail,
                    meta: { title: '订货单详情'}
                },
                {
                    path: '/code',
                    name: '扫码出库',
                    component: Code,
                    meta:{ title: '扫码出库'}
                },
                {
                    path: '/stock',
                    name: '库存管理',
                    component: Stock,
                    meta: { title: '库存管理'}
                },
                {
                    path: '/numbermanage',
                    name: '账号管理',
                    component: Numbermanage,
                    meta: { title: '账号管理'}
                },
                {
                    
                    path: '/sellinput',
                    name: '销售信息录入',
                    component: Sellinput,
                    meta: { title: '销售信息录入'}
                },
                {
                    path: '/waitorder',
                    name: '待核保订单',
                    component: Waitorder,
                    meta: { title: '待核保订单'}
                },
                {
                    path: '/selldetail',
                    name: '订单详情',
                    component: Selldetail,
                    meta: { title: '订单详情'}
                },
                {
                    path: '/waitpayorder',
                    name: '待支付订单',
                    component: Waitpayorder,
                    meta: { title: '待支付订单'}
                },
                {
                    path: '/fulfilorder',
                    name: '已完成订单',
                    component: Fulfilorder,
                    meta: { title: '已完成订单'}
                },
                {
                    path: '/cancelledorder',
                    name: '已取消订单',
                    component: Cancelledorder,
                    meta: { title: '已取消订单'}
                },
                {
                    path: '/failorder',
                    name: '核保失败订单',
                    component: Failorder,
                    meta: { title: '核保失败订单'}
                },
                {
                    path: '/draftbox',
                    name: '草稿箱',
                    component: Draftbox,
                    meta: { title: '草稿箱'}
                },
                {
                    path: '/voidapply',
                    name: '作废申请',
                    component: Voidapply,
                    meta: { title: '作废申请'}
                },
                {
                    path: '/voiddetail',
                    name: '作废详情',
                    component: Voiddetail,
                    meta: { title: '作废详情'}
                },
                {
                    path: '/orderbillcount',
                    name: '对账单统计',
                    component: Orderbillcount,
                    meta: { title: '对账单统计'}
                },
                {
                    path: '/billmanage',
                    name: '对账单统计明细',
                    component: Billmanage,
                    meta: { title: '对账单统计明细'}
                },
                {
                    path: '/inventorydetails',
                    name: '库存明细',
                    component: Inventorydetails,
                    meta: { title: '库存明细'}
                },
                {
                    
                    path: '/returnorder',
                    name: '退货单',
                    component: Returnorder,
                    meta: { title: '退货单'}
                },
                {
                    path: '/returnorderdetails',
                    name: '退货单详情',
                    component: Returnorderdetails,
                    meta: { title: '退货单详情'}
                },
                {
                    
                    path: '/supplierAllBack',
                    name: '销售信息录入',
                    component: SupplierAllBack,
                    meta: { title: '销售信息录入'}
                }
            ] 
        } 
    ]
})

// 路由守卫设置
router.beforeEach(function(to, from, next) {
    if (to.path == '/login') {
        return next();
    }
    var shoptoken = window.localStorage.getItem("token");
    console.log(shoptoken,1111111111)
    // 用户没有登录系统(token===null)
    // 该用户还要试图访问除登录以外的其他页面(例如/home)
    // 就强制该用户去登录
    if (shoptoken === null && to.path !== "/login") {
        return next("/login");
    }
    next(); // 放行
});
export default router;